import 'angular:locale/data:pt-br';
import 'angular:locale/data:es-es';
import 'angular:locale/data:it-it';
import 'angular:locale/data:fr-be';
import 'angular:locale/data:fr-ca';
import 'angular:locale/data:en-ca';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
